<template>
    <q-dialog v-if="product && selectedProductDetails"
              :value="modalDetail"
              @hide="close"
              transition-show="scale"
              transition-hide="scale">
        <q-card class="modal-product-preview">
            <div class="modal-header">
                <span class="modal-title">{{ product.name }} {{ product.article }}</span>
                <div class="modal-close" @click="close">
                    <span aria-hidden="true">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                            <path fill="" d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                        </svg>
                    </span>
                </div>
            </div>
            <q-card-section class="modal-content">
                <div class="row">
                    <div class="col-7">
                        <div class="product-header my-1">
                            <div class="product-rating mb-0">
                                <div class="product-rating-stars">
                                    <span v-for="i in 5" class="star icon"
                                          :class="{'fill': product.reviews && i <= Math.round(product.reviews.rating)}"></span>
                                </div>
                                <span class="product-rating-count">{{ product.reviews && product.reviews.count ? product.reviews.count : 0 }} отзывов</span>
                            </div>
                            <div class="flex product-featured-actions">
                                <product-favorite :product-id="product.id" class="product-featured-action m-0"></product-favorite>
                                <product-share :url="selectedProductDetails.url" class="product-featured-action"></product-share>
                            </div>
                        </div>
                        <product-detail-carousel :items='selectedProductDetails.images' :zoom="true" :options="{breakpoints: {1024: {slidesPerView: 1}}}"></product-detail-carousel>
                    </div>
                    <div class="col">
                        <div class="product product-preview mt-4">
                            <template v-if="product.status">
                                <product-price :product="product" class="product-price" />
                                <div v-if="product.size_required && product.sizes && product.sizes.length"
                                     class="product-size">
                                    <span class="product-select-title">Размеры</span>
                                    <div class="product-size-items" :data-id="product.id">
                                        <div v-for="size in product.sizes"
                                             class="product-size-item"
                                             :class="{ active : sizeSelected(product.id, size), 'product-size-item-long': size.length > 4 }"
                                             @click.prevent="toggleSize({ productId: product.id, size: size })">{{ size }}
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="product-select mb-4">
                                    <div v-if="product.price" class="last-price">Последняя цена:</div>
                                    <div v-if="product.price" class="product-price">
                                        <div class="product-price-container">
                                            <div class="product-price-total product-price-total--sale">
                                                {{ product.price }} &#8381;
                                            </div>
                                        </div>
                                    </div>
                                    <div class="out-of-stock">Нет в наличии</div>
                                    <span class="btn btn-outline add-to-waiting-list mb-2"
                                          @click="loginForWaitingList">Сообщить о поступлении</span>
                                </div>
                            </template>
                            <span class="product-select-title">Характеристики</span>
                            <ul class="product-param-list mr-auto">
                                <li class="product-param-item">
                                    <span class="product-param-name-trait">Бренд</span>
                                    <hr class="product-param-hr-trait">
                                    <span class="product-param-name">{{ product.brand }}</span>
                                </li>
                                <li v-for="displayedOption in displayedOptions" class="product-param-item">
                                    <span class="product-param-name-trait">{{ displayedOption.name }}</span>
                                    <hr class="product-param-hr-trait">
                                    <span class="product-param-name">
                                        <span v-for="optionValue in displayedOption.value">{{ optionValue }}</span>
                                    </span>
                                </li>
                            </ul>
                            <a :href="product.url" class="link mr-auto">Подробнее</a>
                            <div v-if="product.status" class="product-actions">
                                <span :data-id="product.id"
                                      :data-size_required="product.size_required"
                                      class="product-add-to-cart m-0 w-100"
                                      @click.prevent="addToCart">
                                    <span>Добавить в корзину</span>
                                </span>
                            </div>
                            <div v-if="product.status" class="product-actions">
                                <span class="product-one-click m-0 w-100" @click="oneClickOrder">Купить в 1 клик</span>
                            </div>
                        </div>
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>

<script>
import {mapState, mapMutations, mapGetters, mapActions} from 'vuex';
import Template from "../AdminPanel/Content/TemplateForm";
import _ from "lodash";

export default {
    components: {Template},
    computed: {
        ...mapState('auth', ['logged']),
        ...mapState('product', ['product', 'modalDetail']),
        ...mapGetters('product', ['productSizes', 'sizeSelected']),
        displayedOptions () {
            return _.get(this.selectedProductDetails, 'displayed_options', []);
        },
        selectedProductDetails() {
            return this.$store.getters["product/getSelectedProductDetails"](this.product.id);
        },
    },
    watch: {
        modalDetail () {
            this.clearSelection();
        }
    },
    methods: {
        ...mapMutations({
            hideDetailModal: 'product/hideDetailModal',
            toggleSize: 'product/toggleSize',
            toggleDetailModal: 'product/toggleDetailModal',
            clearSelection: 'product/clearSelection',
            showAddToCartModal: 'cart/showAddToCartModal',
            showProductSizeModal: 'product/showProductSizeModal',
            showOneClickOrderModal: 'cart/showOneClickOrderModal',
            updateCartErase: 'cart/updateCartErase',
            stayOnPageAfterAuth: 'auth/stayOnPageAfterAuth',
            showAuthModal: 'auth/showModal',
        }),
        ...mapMutations('product', [
            'setProduct',
        ]),
        ...mapActions({
            addProduct: 'cart/addProduct',
        }),
        oneClickOrder() {
            this.addProduct({
                productId: this.product.id,
                sizeRequired: this.product.size_required,
                erase: true
            })
            .then(() => {
                this.hideDetailModal();
                this.showOneClickOrderModal();
            })
            .catch(error => {
                if (error.reason === 'no_size_selected') {
                    this.showProductSizeModal([{'cart/toggleOneClickOrderModal': true}]);
                } else if (error.response && error.response.data && error.response.data.product) {
                    this.setProduct(error.response.data.product);
                }
            });
        },
        addToCart() {
            this.addProduct({
                productId: this.product.id,
                sizeRequired: this.product.size_required
            })
            .then(() => {
                this.hideDetailModal();
                this.showAddToCartModal();
            })
            .catch(error => {
                if (error.reason === 'no_size_selected') {
                    this.showProductSizeModal([{'cart/toggleAddToCartModal': true}]);
                } else if (_.has(error, 'response.data.product')) {
                    this.setProduct(error.response.data.product);
                }
            });
        },
        close() {
            this.toggleDetailModal(false);
        },
        loginForWaitingList () {
            this.stayOnPageAfterAuth('addToWaitingList');
            this.showAuthModal();
        }
    }
}
</script>
